module.exports = __webpack_public_path__ + "static/img/2.93fe2bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Cumplimiento-Disposiciones-Legales/2.png
// module id = XhM7
// module chunks = 0